/**
 * @file Generated by js-routes 2.3.6. Based on Rails 7.1.3 routes of Certhbootstrap::Application.
 * @version 52d797b8059931518363a79fa016da8cf13334a4038bcb6c216418622661b60c
 * @see https://github.com/railsware/js-routes
 */
// eslint-disable-next-line
const __jsr = (
// eslint-disable-next-line
() => {
    const hasProp = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    const ModuleReferences = {
        CJS: {
            define(routes) {
                if (module) {
                    module.exports = routes;
                }
            },
            isSupported() {
                return typeof module === "object";
            },
        },
        AMD: {
            define(routes) {
                if (define) {
                    define([], function () {
                        return routes;
                    });
                }
            },
            isSupported() {
                return typeof define === "function" && !!define.amd;
            },
        },
        UMD: {
            define(routes) {
                if (ModuleReferences.AMD.isSupported()) {
                    ModuleReferences.AMD.define(routes);
                }
                else {
                    if (ModuleReferences.CJS.isSupported()) {
                        try {
                            ModuleReferences.CJS.define(routes);
                        }
                        catch (error) {
                            if (error.name !== "TypeError")
                                throw error;
                        }
                    }
                }
            },
            isSupported() {
                return (ModuleReferences.AMD.isSupported() ||
                    ModuleReferences.CJS.isSupported());
            },
        },
        ESM: {
            define() {
                // Module can only be defined using ruby code generation
            },
            isSupported() {
                // Its impossible to check if "export" keyword is supported
                return true;
            },
        },
        NIL: {
            define() {
                // Defined using const __jsr = 
            },
            isSupported() {
                return true;
            },
        },
        DTS: {
            // Acts the same as ESM
            define(routes) {
                ModuleReferences.ESM.define(routes);
            },
            isSupported() {
                return ModuleReferences.ESM.isSupported();
            },
        },
    };
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
        "script_name",
    ];
    class UtilsClass {
        constructor() {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "_options",
                serializer: null || this.default_serializer.bind(this),
            };
        }
        default_serializer(value, prefix) {
            if (!prefix && !this.is_object(value)) {
                throw new Error("Url parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                for (const element of value) {
                    result.push(this.default_serializer(element, prefix + "[]"));
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (prefix) {
                        key = prefix + "[" + key + "]";
                    }
                    const subvalue = this.default_serializer(prop, key);
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else {
                result.push(this.is_not_nullable(value) ||
                    true
                    ? encodeURIComponent(prefix) +
                        "=" +
                        encodeURIComponent("" + (value !== null && value !== void 0 ? value : ""))
                    : encodeURIComponent(prefix));
            }
            return result.join("&");
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) &&
                    !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (false &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            // eslint-disable-next-line prefer-const
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            let { trailing_slash, anchor, script_name } = keyword_parameters;
            const missing_params = required_params.filter((param) => !hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            if (anchor) {
                result += "#" + anchor;
            }
            if (script_name) {
                const last_index = script_name.length - 1;
                if (script_name[last_index] == "/" && result[0] == "/") {
                    script_name = script_name.slice(0, last_index);
                }
                result = script_name + result;
            }
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                    break;
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        configure(new_config) {
            if (new_config.prefix) {
                console.warn("JsRoutes configuration prefix option is deprecated in favor of default_url_options.script_name.");
            }
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        is_module_supported(name) {
            return ModuleReferences[name].isSupported();
        }
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        }
        define_module(name, module) {
            this.ensure_module_supported(name);
            ModuleReferences[name].define(module);
            return module;
        }
    }
    const utils = new UtilsClass();
    // We want this helper name to be short
    const __jsr = {
        r(parts_table, route_spec, absolute) {
            return utils.route(parts_table, route_spec, absolute);
        },
    };
    return utils.define_module("ESM", {
        ...__jsr,
        configure: (config) => {
            return utils.configure(config);
        },
        config: () => {
            return utils.config();
        },
        serialize: (object) => {
            return utils.serialize(object);
        },
        ...{},
    });
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

/**
 * Generates rails route to
 * /admin/clients(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_clients_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"clients"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/dashboard_vue(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_dashboard_vue_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard_vue"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/stored_lci_ids(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_stored_lci_ids_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"stored_lci_ids"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/access_rules/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_access_rule_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"access_rules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/access_rules(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_access_rules_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"access_rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/admin/access_rules/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_admin_access_rule_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"access_rules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/admin/access_rules(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_admin_access_rules_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"access_rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/admin/clients/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_admin_client_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/admin/clients(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_admin_clients_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"clients"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/admin/remove_logo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_admin_remove_logo_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"remove_logo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/admin/upload_logo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_admin_upload_logo_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"upload_logo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_building_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/auxiliaries(.:format)
 * @param {any} building_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_building_auxiliaries_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"auxiliaries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/auxiliaries/:id(.:format)
 * @param {any} building_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_building_auxiliary_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"auxiliaries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/batteries(.:format)
 * @param {any} building_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_building_batteries_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"batteries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/batteries/:id(.:format)
 * @param {any} building_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_building_battery_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"batteries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/clone(.:format)
 * @param {any} building_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_building_clone_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/connections/:id(.:format)
 * @param {any} building_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_building_connection_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"connections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/connections(.:format)
 * @param {any} building_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_building_connections_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"connections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/data_sources/:id(.:format)
 * @param {any} building_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_building_data_source_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"data_sources"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/data_sources(.:format)
 * @param {any} building_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_building_data_sources_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"data_sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/dhws/:id(.:format)
 * @param {any} building_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_building_dhw_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"dhws"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/dhws(.:format)
 * @param {any} building_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_building_dhws_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"dhws"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/download_report(.:format)
 * @param {any} building_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_building_download_lca_report_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"download_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/hvacs/:id(.:format)
 * @param {any} building_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_building_hvac_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"hvacs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/hvacs(.:format)
 * @param {any} building_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_building_hvacs_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"hvacs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/insulations/:id(.:format)
 * @param {any} building_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_building_insulation_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"insulations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/insulations(.:format)
 * @param {any} building_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_building_insulations_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"insulations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/investments/:id(.:format)
 * @param {any} building_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_building_investment_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"investments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/investments(.:format)
 * @param {any} building_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_building_investments_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"investments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/lca_analysis(.:format)
 * @param {any} building_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_building_lca_analysis_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"lca_analysis"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/lca_district_building(.:format)
 * @param {any} building_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_building_lca_district_building_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"lca_district_building"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/photovoltaics/:id(.:format)
 * @param {any} building_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_building_photovoltaic_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"photovoltaics"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/photovoltaics(.:format)
 * @param {any} building_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_building_photovoltaics_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"photovoltaics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/clients/:id/project-logo(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_building_project_logo_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"project-logo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/scenarios/:id(.:format)
 * @param {any} building_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_building_scenario_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/scenarios/:scenario_id/clone(.:format)
 * @param {any} building_id
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_building_scenario_clone_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/scenarios/:scenario_id/time_series_charts(.:format)
 * @param {any} building_id
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_building_scenario_time_series_charts_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"time_series_charts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/scenarios/:scenario_id/time_series_table(.:format)
 * @param {any} building_id
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_building_scenario_time_series_table_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"time_series_table"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/scenarios(.:format)
 * @param {any} building_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_building_scenarios_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"scenarios"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/wind_turbines/:id(.:format)
 * @param {any} building_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_building_wind_turbine_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"wind_turbines"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/wind_turbines(.:format)
 * @param {any} building_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_building_wind_turbines_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"wind_turbines"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_buildings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/clients(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_clients_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"clients"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_dashboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/districts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_district_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"districts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/districts/:district_id/clone(.:format)
 * @param {any} district_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_district_clone_path = /*#__PURE__*/ __jsr.r({"district_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"districts"],[2,[7,"/"],[2,[3,"district_id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/districts/:district_id/lca_analysis(.:format)
 * @param {any} district_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_district_lca_analysis_path = /*#__PURE__*/ __jsr.r({"district_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"districts"],[2,[7,"/"],[2,[3,"district_id"],[2,[7,"/"],[2,[6,"lca_analysis"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/districts/:district_id/scenarios/:id(.:format)
 * @param {any} district_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_district_scenario_path = /*#__PURE__*/ __jsr.r({"district_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"districts"],[2,[7,"/"],[2,[3,"district_id"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/districts/:district_id/scenarios/:scenario_id/buildings/:building_id/time_series_table(.:format)
 * @param {any} district_id
 * @param {any} scenario_id
 * @param {any} building_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_district_scenario_building_time_series_table_path = /*#__PURE__*/ __jsr.r({"district_id":{"r":true},"scenario_id":{"r":true},"building_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"districts"],[2,[7,"/"],[2,[3,"district_id"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"time_series_table"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/districts/:district_id/scenarios(.:format)
 * @param {any} district_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_district_scenarios_path = /*#__PURE__*/ __jsr.r({"district_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"districts"],[2,[7,"/"],[2,[3,"district_id"],[2,[7,"/"],[2,[6,"scenarios"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/districts/:district_id/time_series_table(.:format)
 * @param {any} district_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_district_time_series_table_path = /*#__PURE__*/ __jsr.r({"district_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"districts"],[2,[7,"/"],[2,[3,"district_id"],[2,[7,"/"],[2,[6,"time_series_table"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/districts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_districts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"districts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/lci_components/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_lci_component_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"lci_components"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/lci_components(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_lci_components_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"lci_components"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_scenario_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/auxiliaries(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_scenario_auxiliaries_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"auxiliaries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/auxiliaries/:id(.:format)
 * @param {any} scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_scenario_auxiliary_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"auxiliaries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/batteries(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_scenario_batteries_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"batteries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/batteries/:id(.:format)
 * @param {any} scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_scenario_battery_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"batteries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/buildings/:id(.:format)
 * @param {any} scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_scenario_building_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/buildings(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_scenario_buildings_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"buildings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/connections/:id(.:format)
 * @param {any} scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_scenario_connection_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"connections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/connections(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_scenario_connections_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"connections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/data_sources/:id(.:format)
 * @param {any} scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_scenario_data_source_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"data_sources"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/data_sources(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_scenario_data_sources_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"data_sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/dhws/:id(.:format)
 * @param {any} scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_scenario_dhw_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"dhws"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/dhws(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_scenario_dhws_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"dhws"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/district_ess/:id(.:format)
 * @param {any} scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_scenario_district_ess_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"district_ess"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/district_ess(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_scenario_district_ess_index_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"district_ess"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/district_plants/:id(.:format)
 * @param {any} scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_scenario_district_plant_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"district_plants"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/district_plants(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_scenario_district_plants_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"district_plants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/hvacs/:id(.:format)
 * @param {any} scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_scenario_hvac_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"hvacs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/hvacs(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_scenario_hvacs_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"hvacs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/infrastructures/:id(.:format)
 * @param {any} scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_scenario_infrastructure_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"infrastructures"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/infrastructures(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_scenario_infrastructures_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"infrastructures"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/insulations/:id(.:format)
 * @param {any} scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_scenario_insulation_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"insulations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/insulations(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_scenario_insulations_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"insulations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/investments/:id(.:format)
 * @param {any} scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_scenario_investment_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"investments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/investments(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_scenario_investments_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"investments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/photovoltaics/:id(.:format)
 * @param {any} scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_scenario_photovoltaic_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"photovoltaics"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/photovoltaics(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_scenario_photovoltaics_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"photovoltaics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/vehicles/:id(.:format)
 * @param {any} scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_scenario_vehicle_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"vehicles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/vehicles(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_scenario_vehicles_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"vehicles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/wind_turbines/:id(.:format)
 * @param {any} scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_scenario_wind_turbine_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"wind_turbines"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/wind_turbines(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_scenario_wind_turbines_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"wind_turbines"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/cancel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_user_registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/auxiliaries/:id/clone(.:format)
 * @param {any} building_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clone_api_v1_building_auxiliary_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"auxiliaries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/batteries/:id/clone(.:format)
 * @param {any} building_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clone_api_v1_building_battery_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"batteries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/dhws/:id/clone(.:format)
 * @param {any} building_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clone_api_v1_building_dhw_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"dhws"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/hvacs/:id/clone(.:format)
 * @param {any} building_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clone_api_v1_building_hvac_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"hvacs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/insulations/:id/clone(.:format)
 * @param {any} building_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clone_api_v1_building_insulation_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"insulations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/photovoltaics/:id/clone(.:format)
 * @param {any} building_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clone_api_v1_building_photovoltaic_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"photovoltaics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/wind_turbines/:id/clone(.:format)
 * @param {any} building_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clone_api_v1_building_wind_turbine_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"wind_turbines"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/auxiliaries/:id/clone(.:format)
 * @param {any} scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clone_api_v1_scenario_auxiliary_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"auxiliaries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/batteries/:id/clone(.:format)
 * @param {any} scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clone_api_v1_scenario_battery_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"batteries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/buildings/:id/clone(.:format)
 * @param {any} scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clone_api_v1_scenario_building_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/dhws/:id/clone(.:format)
 * @param {any} scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clone_api_v1_scenario_dhw_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"dhws"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/district_ess/:id/clone(.:format)
 * @param {any} scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clone_api_v1_scenario_district_ess_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"district_ess"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/district_plants/:id/clone(.:format)
 * @param {any} scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clone_api_v1_scenario_district_plant_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"district_plants"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/hvacs/:id/clone(.:format)
 * @param {any} scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clone_api_v1_scenario_hvac_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"hvacs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/infrastructures/:id/clone(.:format)
 * @param {any} scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clone_api_v1_scenario_infrastructure_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"infrastructures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/insulations/:id/clone(.:format)
 * @param {any} scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clone_api_v1_scenario_insulation_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"insulations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/photovoltaics/:id/clone(.:format)
 * @param {any} scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clone_api_v1_scenario_photovoltaic_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"photovoltaics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/vehicles/:id/clone(.:format)
 * @param {any} scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clone_api_v1_scenario_vehicle_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"vehicles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/wind_turbines/:id/clone(.:format)
 * @param {any} scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clone_api_v1_scenario_wind_turbine_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"wind_turbines"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /contact(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contact_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"contact"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_user_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/scenarios/:id/download_csv(.:format)
 * @param {any} building_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_csv_api_v1_building_scenario_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/districts/:district_id/scenarios/:id/download_csv(.:format)
 * @param {any} district_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_csv_api_v1_district_scenario_path = /*#__PURE__*/ __jsr.r({"district_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"districts"],[2,[7,"/"],[2,[3,"district_id"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/districts/:district_id/scenarios/:scenario_id/buildings/:id/download_csv(.:format)
 * @param {any} district_id
 * @param {any} scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_csv_api_v1_district_scenario_building_path = /*#__PURE__*/ __jsr.r({"district_id":{"r":true},"scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"districts"],[2,[7,"/"],[2,[3,"district_id"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /download_user_guide_b(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_user_guide_b_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"download_user_guide_b"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /download_user_guide_d(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_user_guide_d_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"download_user_guide_d"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/v1/admin/access_rules/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_v1_admin_access_rule_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"access_rules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/admin/clients/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_v1_admin_client_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_v1_building_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/auxiliaries/:id/edit(.:format)
 * @param {any} building_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_v1_building_auxiliary_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"auxiliaries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/batteries/:id/edit(.:format)
 * @param {any} building_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_v1_building_battery_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"batteries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/connections/:id/edit(.:format)
 * @param {any} building_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_v1_building_connection_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"connections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/data_sources/:id/edit(.:format)
 * @param {any} building_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_v1_building_data_source_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"data_sources"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/dhws/:id/edit(.:format)
 * @param {any} building_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_v1_building_dhw_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"dhws"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/hvacs/:id/edit(.:format)
 * @param {any} building_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_v1_building_hvac_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"hvacs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/insulations/:id/edit(.:format)
 * @param {any} building_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_v1_building_insulation_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"insulations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/investments/:id/edit(.:format)
 * @param {any} building_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_v1_building_investment_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"investments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/photovoltaics/:id/edit(.:format)
 * @param {any} building_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_v1_building_photovoltaic_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"photovoltaics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/wind_turbines/:id/edit(.:format)
 * @param {any} building_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_v1_building_wind_turbine_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"wind_turbines"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/districts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_v1_district_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"districts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/lci_components/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_v1_lci_component_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"lci_components"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_v1_scenario_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/auxiliaries/:id/edit(.:format)
 * @param {any} scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_v1_scenario_auxiliary_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"auxiliaries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/batteries/:id/edit(.:format)
 * @param {any} scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_v1_scenario_battery_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"batteries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/buildings/:id/edit(.:format)
 * @param {any} scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_v1_scenario_building_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/connections/:id/edit(.:format)
 * @param {any} scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_v1_scenario_connection_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"connections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/data_sources/:id/edit(.:format)
 * @param {any} scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_v1_scenario_data_source_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"data_sources"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/dhws/:id/edit(.:format)
 * @param {any} scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_v1_scenario_dhw_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"dhws"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/district_ess/:id/edit(.:format)
 * @param {any} scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_v1_scenario_district_ess_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"district_ess"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/district_plants/:id/edit(.:format)
 * @param {any} scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_v1_scenario_district_plant_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"district_plants"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/hvacs/:id/edit(.:format)
 * @param {any} scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_v1_scenario_hvac_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"hvacs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/infrastructures/:id/edit(.:format)
 * @param {any} scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_v1_scenario_infrastructure_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"infrastructures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/insulations/:id/edit(.:format)
 * @param {any} scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_v1_scenario_insulation_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"insulations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/investments/:id/edit(.:format)
 * @param {any} scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_v1_scenario_investment_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"investments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/photovoltaics/:id/edit(.:format)
 * @param {any} scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_v1_scenario_photovoltaic_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"photovoltaics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/vehicles/:id/edit(.:format)
 * @param {any} scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_v1_scenario_vehicle_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"vehicles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/wind_turbines/:id/edit(.:format)
 * @param {any} scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_v1_scenario_wind_turbine_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"wind_turbines"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/districts/:district_id/scenarios/:id/import_from_b(.:format)
 * @param {any} district_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_from_b_api_v1_district_scenario_path = /*#__PURE__*/ __jsr.r({"district_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"districts"],[2,[7,"/"],[2,[3,"district_id"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"import_from_b"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/admin/access_rules/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_v1_admin_access_rule_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"access_rules"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/admin/clients/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_v1_admin_client_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/auxiliaries/new(.:format)
 * @param {any} building_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_v1_building_auxiliary_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"auxiliaries"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/batteries/new(.:format)
 * @param {any} building_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_v1_building_battery_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"batteries"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/connections/new(.:format)
 * @param {any} building_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_v1_building_connection_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"connections"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/data_sources/new(.:format)
 * @param {any} building_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_v1_building_data_source_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"data_sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/dhws/new(.:format)
 * @param {any} building_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_v1_building_dhw_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"dhws"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/hvacs/new(.:format)
 * @param {any} building_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_v1_building_hvac_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"hvacs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/insulations/new(.:format)
 * @param {any} building_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_v1_building_insulation_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"insulations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/investments/new(.:format)
 * @param {any} building_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_v1_building_investment_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"investments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/photovoltaics/new(.:format)
 * @param {any} building_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_v1_building_photovoltaic_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"photovoltaics"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/wind_turbines/new(.:format)
 * @param {any} building_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_v1_building_wind_turbine_path = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"wind_turbines"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/lci_components/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_v1_lci_component_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"lci_components"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/auxiliaries/new(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_v1_scenario_auxiliary_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"auxiliaries"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/batteries/new(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_v1_scenario_battery_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"batteries"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/buildings/new(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_v1_scenario_building_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/connections/new(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_v1_scenario_connection_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"connections"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/data_sources/new(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_v1_scenario_data_source_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"data_sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/dhws/new(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_v1_scenario_dhw_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"dhws"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/district_ess/new(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_v1_scenario_district_ess_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"district_ess"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/district_plants/new(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_v1_scenario_district_plant_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"district_plants"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/hvacs/new(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_v1_scenario_hvac_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"hvacs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/infrastructures/new(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_v1_scenario_infrastructure_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"infrastructures"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/insulations/new(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_v1_scenario_insulation_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"insulations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/investments/new(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_v1_scenario_investment_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"investments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/photovoltaics/new(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_v1_scenario_photovoltaic_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"photovoltaics"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/vehicles/new(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_v1_scenario_vehicle_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"vehicles"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scenarios/:scenario_id/wind_turbines/new(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_v1_scenario_wind_turbine_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"wind_turbines"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_source_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_up"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /docs
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oas_rails_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"docs"]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_path = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_proxy_path = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/incinerate(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_incinerate_path = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"incinerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/reroute(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_reroute_path = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"reroute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_sources_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/direct_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_direct_uploads_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_key/*filename(.:format)
 * @param {any} encoded_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_disk_service_path = /*#__PURE__*/ __jsr.r({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mailgun/inbound_emails/mime(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mailgun_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"mime"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_health_check_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/postmark/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_postmark_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"postmark"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/relay/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_relay_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"relay"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/sendgrid/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_sendgrid_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"sendgrid"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/redirect/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_path = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/proxy/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_proxy_path = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const root_path = /*#__PURE__*/ __jsr.r({}, [7,"/"]);

/**
 * Generates rails route to
 * /terms-of-use(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const terms_of_use_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"terms-of-use"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_token(.:format)
 * @param {any} encoded_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_rails_disk_service_path = /*#__PURE__*/ __jsr.r({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /user_guide(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_guide_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user_guide"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /video-guides(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const video_guides_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"video-guides"],[1,[2,[8,"."],[3,"format"]]]]]);

